import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import Collage from '../components/Collage'
import { openLoginFormRequest } from '../actions'


class ResetPasswordResult extends Component {

  componentWillMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }

  }

  render() {

    let result = this.props.params.result;
    let message = 'Password reset successful';
    if (result !== 'success') {
      message = 'Password reset failed';
    }
    return (
      <div className="forgot-content">
        <Collage />

        <div className="forgot-wrapper">
          <div className="forgot-title">{message}</div>
          {result === 'success' ? (
            <button onClick={(e) => { e.preventDefault(); this.props.openLoginFormRequest() }}
              className="button button-primary">Go to Login</button>
          ) : (
            <Link to={'/user/forgotpassword'}><button className="button button-primary">Go to Forgot password</button></Link>
          )}
        </div>
      </div>
    );
  }

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push
  },
  { openLoginFormRequest }
)(ResetPasswordResult);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordResult.jsx